var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('navigation'),(_vm.$route.meta.keepAlive)?_c('keep-alive',[_c('router-view',{staticClass:"font-none"})],1):_vm._e(),(!_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"font-none"}):_vm._e(),_c('navigation-bottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }